import { useReveal } from '../../hooks/useReveal';

export const Reveal = ({ children, className = '', delay = 0 }) => {
  const ref = useReveal();

  return (
    <div ref={ref} className={`reveal ${className}`} style={{ '--reveal-delay': `${delay}ms` }}>
      {children}
    </div>
  );
};
